export default __webpack_public_path__ + "static/media/skyship6.983df6ed.webp";